import React from "react";

const Footer = () => {
  return (
    <div className="section bg_gray">
      <div className="content">
        <div className="notice">
          <h3 className="stit">이용안내</h3>
          <div className="noti_wrap">
            <ul>
              <li>
                {" "}
                본 투자 서비스는 ㈜비단골드가 운영하는 “비단” 앱에서 제공하는
                것입니다.
              </li>
              <li>
                {" "}
                본 투자 서비스를 이용하시기 전 제공되는 정보에 대해 꼼꼼히
                확인해 주시기 바랍니다.
              </li>
              <li>
                {" "}
                “e금”, “e은”은 실물 금(순도 99.99%)을 제공 받을 수 있는
                모바일상품권입니다.
              </li>
              <li>
                {" "}
                “e금“, “e은”은 국제시세 및 환율과 연동된 가격으로 거래되며, 최소
                거래가능 단위는 e금 0.0001g, e은 0.01 입니다.
              </li>
              <li>
                {" "}
                “e금”, “e은”의 시세 급등락에 따른 손실이 발생할 수 있으므로,
                거래 시 유의하시기 바랍니다.
              </li>
              <li>
                {" "}
                본 투자 서비스를 통한 판매되는 “e금”, “e은” 시세에 따라 가치가
                변화되는 만큼 구매한 “e금”, “e은”에 대한 환불은 되지 않습니다.
              </li>
              <li>
                {" "}
                회원이 구매한 “e금”, “e은”의 매도는 “비단” 앱에서만 가능합니다.
              </li>
              <li>
                {" "}
                기타 “e금”, “e은” 거래와 관련한 상세한 설명은 “비단” 앱서비스를
                참고하시기 바랍니다.
              </li>
              <li>
                {" "}
                상세한 문의는 “비단” 앱 서비스 고객센터 02-1670-8456 으로 문의
                바랍니다.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
